import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'g10-global-settings',
  templateUrl: './global-settings.component.html',
  styleUrls: ['./global-settings.component.css']
})
export class GlobalSettingsComponent implements OnInit {
  
  public activeMenu = 'mail-configuration';

  customMailDescription = `
  <h5>Welcome</h5>
  `;

  public sideNavMenuHeight = '100px';
  public sideNavMenu = [{
    label: 'Custom Mail Subject',
    url:'mail-configuration',
    materialIcon:false,
    icon: 'EditMail',
    id:'gblSettingMenuDashboard'
  },
  {
    label: 'Booking Day Count',
    icon: 'book_online',
    url:'booking-day-configuration',
    materialIcon:true,
    id:'gblSettingMenuBookingDay'
  },
  {
    label: 'Open Booking',
    icon: 'book_online',
    url:'openbooking-status',
    materialIcon:true,
    id:'gblSettingBookingCount'
  },
  // {
  //   label: 'Request',
  //   icon: 'compare_arrows',
  //   id:'gblSettingMenuRequest'
  // },

  // {
  //   label: 'Route / Rostering',
  //   icon: 'call_split',
  //   id:'gblSettingMenuRouteRostering'

  // },
  // {
  //   label: 'Reports',
  //   icon: 'insert_chart_outlined',
  //   id:'gblSettingMenuReports'
  // },
  // {
  //   label: 'Information',
  //   icon: 'info',
  //   id:'gblSettingMenuInformation'
  // },
  // {
  //   label: 'Support Desk',
  //   icon: 'contact_support',
  //   id:'gblSettingMenuSupportDesk'
  // },
  /* {
    label: 'Campaigns',
    icon: 'mail_outline',
    path: '/organization/transport-manager/campaigns',
  }, */
  ];
  
  constructor(private route:ActivatedRoute,private router:Router) { }


  ngOnInit(): void {
    // this.sideNavMenuHeight = (this.sideNavMenu.length * 100)+'px';
    this.route.paramMap.subscribe((params: any) => {
      if(params.params.settingType){
        this.activeMenu = params.params.settingType;
      }
    });
  }

  settingMenuChanges(e,menu){
    e.preventDefault();
    this.activeMenu = menu;
    // console.log('/organization/transport-manager/information/orgInfo/global-settings/'+menu)
    this.router.navigate(['/organization/transport-manager/information/orgInfo/global-settings', menu]);
  }
}
